import type { FlavorConfig } from '@/types/flavor';

/**
 * Sideconvo QA Environment Configuration
 */
const config: FlavorConfig = {
  name: 'sideconvo',
  environment: 'qa',
  appTitle: 'Lead Management | Sideconvo.ai [QA]',
  firestoreDB: 'lead-management-qa',
  demoSiteBaseUrl: 'https://qa.client.sideconvo.ai',
  snapshotBucket: 'snapshot-sideconvo-qa',
};

export default config;
